import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PubQuotes from './views/PubQuotes.vue'
import LoginView from './views/LoginView.vue'
import ResetPassword from './views/ResetPassword.vue'
import { TokenService } from './services/storage.service'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/pub-quotes',
      name: 'pub-quotes',
      component: PubQuotes
    },
    {
      path: '/int-quotes',
      name: 'int-quotes',
      component: PubQuotes
    },
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        public: true, //allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        public: true, //allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/item-search',
      name: 'item-search',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/ItemSearch.vue')
    },
    {
      path: '/quote-doc/:id',
      name: 'quote-doc',
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/QuoteDoc.vue'),
      meta: {
        public: true, //allow access to even if not logged in
        // onlyWhenLoggedOut: true
      }
    },
    {
      path: '/pub-quote-new',
      name: 'pub-quote-new',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/PubQuoteEdit.vue')
    },
    {
      path: '/pub-quote-edit/:id',
      name: 'pub-quote-edit',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/PubQuoteEdit.vue')
    },
    {
      path: '/pub-quote-board/:id',
      name: 'pub-quote-board',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/PubQuoteBoard.vue')
    },
    {
      path: '/int-quote-board/:id',
      name: 'int-quote-board',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/InternalQuoteBoard.vue')
    },
    {
      path: '/admin/settings',
      name: 'admin-settings',
      // route level code-splitting
      // this generates a separate chunk (pubquoteedit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/Home.vue')
      component: () => import(/* webpackChunkName: "pubquoteedit" */ './views/admin/Settings.vue')
    },
    {
      path: '/admin/regions',
      name: 'admin-regions',
      component: () => import('./views/admin/Regions.vue')
    },
    // {
    //   path: '/admin/region/new',
    //   name: 'admin-region-new',
    //   component: () => import('./views/admin/RegionEdit.vue')
    // },
    {
      path: '/admin/territories',
      name: 'admin-territories',
      component: () => import('./views/admin/Territories.vue')
    },
    {
      path: '/admin/item-class',
      name: 'admin-item-class',
      component: () => import('./views/admin/ItemClassShowHideAdmin.vue')
    },
    {
      path: '/admin/admin-taz-import',
      name: 'admin-taz-import',
      component: () => import('./views/admin/TazImport.vue')
    },
    // {
    //   path: '/admin/territory/new',
    //   name: 'admin-territory-new',
    //   component: () => import('./views/admin/RegionEdit.vue')
    // },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('./views/admin/Users.vue')
    },
    {
      path: '/admin/item-images',
      name: 'admin-item-images',
      component: () => import('./views/admin/ItemImageProcess.vue')
    },
    {
      path: '/admin/item-image-admim',
      name: 'admin-item-image-admin',
      component: () => import('./views/admin/ItemImageAdmin.vue')
    },
    {
      path: '/admin/item-images-canto',
      name: 'admin-item-images-canto',
      component: () => import('./views/admin/ItemImageProcessCanto.vue')
    },
    {
      path: '/admin/userSignup',
      name: 'admin-user-signup',
      component: () => import('./views/admin/UserSignup.vue')
    },
    {
      path: '/admin/userEdit/:id',
      name: 'admin-user-edit',
      component: () => import('./views/admin/UserSignup.vue')
    },
    {
      path: '/admin/publicSiteSecurityAdmin',
      name: 'public-site-security-admin',
      component: () => import('./views/admin/PublicSiteSecurityAdmin.vue')
    },
    {
      path: '/admin/admin-quote-templates',
      name: 'admin-quote-templates',
      component: () => import('./views/admin/QuoteTemplates.vue')
    },
    {
      path: '/admin/admin-quote-template/:id',
      name: 'admin-quote-template',
      component: () => import('./views/admin/QuoteTemplate.vue')
    },
    {
      path: '/admin/admin-item-promotions',
      name: 'admin-item-promotions',
      component: () => import('./views/admin/ItemPromotions.vue')
    },
    // TAZ related pages
    {
      path: '/admin/salesRepSearch',
      name: 'sales-rep-search',
      component: () => import('./views/terrAssignDb/terrAssignDbSalesRepSearch.vue')
    },
    {
      path: '/tools/zipsAssignMapSavedList/',
      name: 'zips-assign-map-saved-list',
      component: () => import('./views/tools/zipsAssignMapSavedList.vue')
    },
    {
      path: '/tools/zipsAssignMapSaved/:id',
      name: 'zips-assign-map-saved',
      component: () => import('./views/tools/zipsAssignMap.vue')
    },
    {
      path: '/tools/zipsAssignMap',
      name: 'zips-assign-map',
      component: () => import('./views/tools/zipsAssignMap.vue')
    },
    // End TAZ related pages
    
    // Prod DB related pages
    {
      path: '/admin/initialImportProdDbData',
      name: 'initialImportProdDbData',
      component: () => import('./views/admin/InitialImportProdDbData.vue')
    },
    {
      path: '/admin/itemDocs',
      name: 'itemDocs',
      component: () => import('./views/admin/ItemDocs.vue')
    },
    {
      path: '/admin/itemProdDbItems',
      name: 'itemProdDbItems',
      component: () => import('./views/admin/ItemProdDbItems.vue')
    },
    {
      path: '/admin/itemMapNewGpItmToProdDb',
      name: 'itemMapNewGpItmToProdDb',
      component: () => import('./views/admin/ItemMapNewGpItmToProdDb.vue')
    },
    // End Prod DB related pages
    
    // GPO related pages
    {
      path: '/gpo/contracts',
      name: 'gpo-contracts',
      component: () => import('./views/tools/FolderFileNav.vue')
    },
    {
      path: '/tools/CapsContractHotSheet/:id',
      name: 'contract-hotsheet',
      component: () => import('./views/tools/CapsContractHotSheet.vue')
    },
    // End GPO related pages
  ]
});

router.beforeEach((to, from, next) => {
  // console.table(to)
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next();
})


export default router;